__webpack_require__.p = "https://just-scan-dev.gft-dev.ro/scan/";